import { getLocalApiOrigin } from '../utils/localApi';
import { sorceryImageUrl } from '../utils/cardImageUrl';
import {
  SITES_BOOSTERS,
  isSitesBoosterKey,
} from '../utils/arena/packsApi';

function SitesBoosterStack({ setKey, width, height }) {
  const pack = SITES_BOOSTERS[setKey];
  if (!pack) return null;
  const origin = getLocalApiOrigin();
  const siteSrc = sorceryImageUrl(pack.featuredSiteSlug, origin);
  const boosterSrc = `${origin}/game-assets/booster-${pack.sourceSetKey}.webp`;
  return (
    <div className="relative" style={{ width, height }}>
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, rgba(212,168,67,0.2) 0%, transparent 70%)',
          filter: 'blur(6px)',
        }}
      />
      <img
        src={siteSrc}
        alt=""
        className="absolute pointer-events-none"
        style={{
          width: '63%',
          height: 'auto',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%) rotate(90deg)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: '0 6px 18px rgba(0,0,0,0.7), 0 0 0 1px rgba(212,168,67,0.35)',
          filter: 'brightness(0.78) saturate(1.05)',
        }}
        draggable={false}
      />
      <img
        src={boosterSrc}
        alt={pack.label}
        className="absolute pointer-events-none"
        style={{
          height: '100%',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%) rotate(-5deg)',
          filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.85))',
        }}
        draggable={false}
      />
    </div>
  );
}

// Composite preview for Sites Boosters (featured horizontal site
// backdrop + booster pack art on top). Returns null for any other
// setKey so callers can fall back to their existing single-image
// renderer.
export function ProductPreview({ setKey, width, height }) {
  if (isSitesBoosterKey(setKey)) return <SitesBoosterStack setKey={setKey} width={width} height={height} />;
  return null;
}

export function hasProductPreview(setKey) {
  return isSitesBoosterKey(setKey);
}
